import React, { useEffect, useState } from 'react';

import { FilePond, registerPlugin } from 'react-filepond';



import { acceptedUploadFiles } from 'common/api';
import { FilePondErrorDescription, FilePondFile } from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

//import fr from 'filepond/locale/fr-fr';

// @ts-ignore comment
//import * as fr from 'filepond/locale/fr-fr.js';




registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateType);

// react webcam !!! yeah -> https://www.npmjs.com/package/react-webcam
// autre source pour utiliser camera
// https://stackoverflow.com/questions/58806971/how-can-i-take-a-picture-in-react-web-application-not-native


export default (props: { acceptedUploadFiles?: string[], multiple?: boolean, onChange: (fileIds: number[]) => void; }) => {

    const [uploadedFiles, setUploadedFiles] = useState<number[]>([]);
    const [files, setFiles] = useState<any[]>([]);

    useEffect(() => {
        console.log('uploadedFiles', uploadedFiles);
        props.onChange(uploadedFiles);
    }, [uploadedFiles]);

    const onProcessFile = (error: FilePondErrorDescription | null, file: FilePondFile) => {
        console.log('error', error);
        if (error) {
            if (error.code) {
                const statusCode = parseInt(error.code + '');

                if (statusCode) {
                    switch (statusCode) {
                        case 413:
                            return alert('Le fichier transmit excède la limite autorisée. Veuillez sélectionner un fichier moins volumineux');
                        case 415:
                            return alert(`Type de fichier non autorisé. Veuillez choisir une photo, une image ou un document pdf.`);
                        default:
                            break;
                    }
                }
            }
        }
    };

    return <div><FilePond
        labelInvalidField="Le champ contient des fichiers invalides"
        labelFileWaitingForSize="En attente de taille"
        labelFileSizeNotAvailable="Taille non disponible"
        labelFileLoading="Chargement"
        labelFileLoadError="Erreur durant le chargement"
        labelFileProcessing="Traitement"
        labelFileProcessingComplete="Traitement effectué"
        labelFileProcessingAborted="Traitement interrompu"
        labelFileProcessingError="Erreur durant le traitement"
        labelFileProcessingRevertError="Erreur durant la restauration"
        labelFileRemoveError="Erreur durant la suppression"
        labelTapToCancel="appuyer pour annuler"
        labelTapToRetry="appuyer pour réessayer"
        labelTapToUndo="appuyer pour revenir en arrière"
        labelButtonRemoveItem="Retirer"
        labelButtonAbortItemLoad="Annuler"
        labelButtonRetryItemLoad="Recommencer"
        labelButtonAbortItemProcessing="Annuler"
        labelButtonUndoItemProcessing="Revenir en arrière"
        labelButtonRetryItemProcessing="Recommencer"
        labelButtonProcessItem="Transférer"
        labelDecimalSeparator=','
        labelFileAdded='Ajouté'
        labelFileCountPlural='fichier'
        labelFileCountSingular=' fichier'
        labelFileRemoved='Supprimé'
        labelThousandsSeparator=' '
        /*labelMaxFileSizeExceeded="Le fichier est trop volumineux"*/
        /*labelMaxFileSize="La taille maximale de fichier est {filesize}"*/
        /*labelMaxTotalFileSizeExceeded="Taille totale maximale dépassée"*/
        /*labelMaxTotalFileSize="La taille totale maximale des fichiers est {filesize}"*/
        fileValidateTypeLabelExpectedTypes="Attendu {allButLastType} ou {lastType}"
        /*imageValidateSizeLabelFormatError="Type d'image non pris en charge"*/
        /*imageValidateSizeLabelImageSizeTooSmall="L'image est trop petite"*/
        /*imageValidateSizeLabelImageSizeTooBig="L'image est trop grande"*/
        /*imageValidateSizeLabelExpectedMinSize="La taille minimale est {minWidth} × {minHeight}"*/
        /*imageValidateSizeLabelExpectedMaxSize="La taille maximale est {maxWidth} × {maxHeight}"*/
        /*imageValidateSizeLabelImageResolutionTooLow="La résolution est trop faible"*/
        /*imageValidateSizeLabelImageResolutionTooHigh="La résolution est trop élevée"*/
        /*imageValidateSizeLabelExpectedMinResolution="La résolution minimale est {minResolution}"*/
        /*imageValidateSizeLabelExpectedMaxResolution="La résolution maximale est {maxResolution}"*/
        files={files}
        labelFileTypeNotAllowed={'Seules les images (JPG / PNG) et les documents pdf sont autorisés.'}
        onupdatefiles={setFiles}
        onprocessfile={onProcessFile}
        allowMultiple={props.multiple === true}
        maxFiles={10}
        acceptedFileTypes={props.acceptedUploadFiles ?? acceptedUploadFiles}
        server={{
            headers: {
                'Accept': 'application/json'
            },
            process: {
                url: "/file/upload",
                onload: (res) => {
                    const serverResult: { success: boolean, content: any; } = JSON.parse(res);

                    if (serverResult.success === true) {

                        setUploadedFiles(p => {

                            return p.concat([serverResult.content]);
                        });
                    }
                    return res;
                },
                onerror: (responseBody: any) => {

                    try {
                        const response = JSON.parse(responseBody ?? '');
                        if (response && 'content' in response && response.content) {
                            alert(response.content);
                        }
                    } catch (err) {
                        // do nithing
                        alert('Un erreur a e lieu. Impossible de télécharger le fichier sélectionné');
                    }
                }
            }
        }}
        allowImagePreview={false}
        name="file" /* sets the file input name, it's filepond by default */
        labelIdle='Déplacer les fichiers ici ou <span class="filepond--label-action">choisir des fichier</span>'
    /></div >;
};
